<div id="ht">
    <div id="main-cnt">
        <ion-header>
            <ion-toolbar>
                Inserisci i tuoi dati
            </ion-toolbar>
        </ion-header>
        <ion-content class="main-content">
            <div class="scroller-container">
                <div class="content-scroller">
                    <div class="content">

                        <ion-label position="floating">Nome</ion-label>
                        <ion-input [(ngModel)]="name" class="text-input" placeholder="Es Mario"></ion-input>
                        <ion-label position="floating">Cognome</ion-label>
                        <ion-input [(ngModel)]="lastName" class="text-input" placeholder="Es. Rossi"></ion-input>
                        <ion-button (click)="submit()">Salva</ion-button>
                    </div>
                </div>
            </div>
        </ion-content>
    </div>
</div>